import React from 'react';
import './Styles/FirstPart.scss';
import profile from '../../../Assets/Cards/detailProfile.png';
import {FaFacebookF , FaTwitter} from 'react-icons/fa';
import {AiOutlineInstagram , AiFillYoutube} from 'react-icons/ai';
export const icons = [
    <FaFacebookF /> , <FaTwitter />, <AiOutlineInstagram />,<AiFillYoutube />
  ]
const FirstPart=()=>{
    return(
        <div className="details-first-part">
            <h3>tutorials + resources</h3>
            <h1  data-aos="fade-right"
        data-aos-delay={100}>Who are so beguiled and demoralized by the charms of pleasure of the moment</h1>
            <div className="profile">
                <div className="info">
                    <div  data-aos="fade-right"
        data-aos-delay={200}> 
                        <img src={profile} />
                    </div>
                    <div >
                        <h2>Megan Hendrickson</h2>
                        <p>April 4,2019  10 min read</p>
                    </div>
                </div>
                <div className="icons"  data-aos="fade-left"
        data-aos-delay={200}>
                  
            {icons.map((icon) =>{
                return(
                    <div className="circle">
                <div className="icon">
                  {icon}
                  </div>
              </div>
              )
            })}
          </div>
            </div>
            <div className="image-part"></div>
        </div>
    )
};
export default FirstPart;